export const IconCashier = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconCashier_svg__a"
        width={23}
        height={23}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M0 0h23v23H0z" />
        <path
          fillRule="evenodd"
          d="M22.5 16.75a.75.75 0 0 0-.75-.75h-20a.75.75 0 0 0-.75.75v4c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-1.5.75v3.25a.25.25 0 0 1-.25.25h-18a.25.25 0 0 1-.25-.25V17.5zM21.5 2.75c0-.464-.184-.909-.513-1.237A1.75 1.75 0 0 0 19.75 1h-7c-.464 0-.909.184-1.237.513A1.75 1.75 0 0 0 11 2.75v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h7c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-1.5 0v3a.25.25 0 0 1-.25.25h-7a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25h7a.25.25 0 0 1 .25.25"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M21.609 10.019A1.75 1.75 0 0 0 19.874 8.5H3.626a1.75 1.75 0 0 0-1.735 1.519l-.884 6.632a.747.747 0 0 0 .743.849h20a.748.748 0 0 0 .743-.849zm-1.487.198L20.893 16H2.607l.771-5.783A.25.25 0 0 1 3.625 10h16.249a.25.25 0 0 1 .248.217M9.75 20h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M16.75 12.5h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M13.25 12.5h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M16.75 15h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M13.25 15h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M17 9.25v-2.5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0M5.25 13.5h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5"
          clipRule="evenodd"
        />
      </mask>
      <path
        fillRule="evenodd"
        d="M22.5 16.75a.75.75 0 0 0-.75-.75h-20a.75.75 0 0 0-.75.75v4c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-1.5.75v3.25a.25.25 0 0 1-.25.25h-18a.25.25 0 0 1-.25-.25V17.5zM21.5 2.75c0-.464-.184-.909-.513-1.237A1.75 1.75 0 0 0 19.75 1h-7c-.464 0-.909.184-1.237.513A1.75 1.75 0 0 0 11 2.75v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h7c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-1.5 0v3a.25.25 0 0 1-.25.25h-7a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25h7a.25.25 0 0 1 .25.25"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M21.609 10.019A1.75 1.75 0 0 0 19.874 8.5H3.626a1.75 1.75 0 0 0-1.735 1.519l-.884 6.632a.747.747 0 0 0 .743.849h20a.748.748 0 0 0 .743-.849zm-1.487.198L20.893 16H2.607l.771-5.783A.25.25 0 0 1 3.625 10h16.249a.25.25 0 0 1 .248.217M9.75 20h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M16.75 12.5h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M13.25 12.5h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M16.75 15h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M13.25 15h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M17 9.25v-2.5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0M5.25 13.5h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M22.5 16.75a.75.75 0 0 0-.75-.75h-20a.75.75 0 0 0-.75.75v4c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h18c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-1.5.75v3.25a.25.25 0 0 1-.25.25h-18a.25.25 0 0 1-.25-.25V17.5zM21.5 2.75c0-.464-.184-.909-.513-1.237A1.75 1.75 0 0 0 19.75 1h-7c-.464 0-.909.184-1.237.513A1.75 1.75 0 0 0 11 2.75v3c0 .464.184.909.513 1.237.328.329.773.513 1.237.513h7c.464 0 .909-.184 1.237-.513.329-.328.513-.773.513-1.237zm-1.5 0v3a.25.25 0 0 1-.25.25h-7a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25h7a.25.25 0 0 1 .25.25"
        clipRule="evenodd"
        mask="url(#IconCashier_svg__a)"
      />
      <path
        fillRule="evenodd"
        d="M21.609 10.019A1.75 1.75 0 0 0 19.874 8.5H3.626a1.75 1.75 0 0 0-1.735 1.519l-.884 6.632a.747.747 0 0 0 .743.849h20a.748.748 0 0 0 .743-.849zm-1.487.198L20.893 16H2.607l.771-5.783A.25.25 0 0 1 3.625 10h16.249a.25.25 0 0 1 .248.217M9.75 20h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5"
        clipRule="evenodd"
        mask="url(#IconCashier_svg__a)"
      />
      <path
        fillRule="evenodd"
        d="M16.75 12.5h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M13.25 12.5h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M16.75 15h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M13.25 15h1a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5M17 9.25v-2.5a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0M5.25 13.5h4a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5"
        clipRule="evenodd"
        mask="url(#IconCashier_svg__a)"
      />
    </svg>
  );
};
